import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';

export interface RecommendedSourceDTO {
	url: string;
	ari: string;
	parentAri?: string | null;
}

export interface RecommendedThreadDTO {
	id: string;
	title: string;
	summary: string;
	sources: RecommendedSourceDTO[];
	suggestedActions: unknown[];
	conversationStarters: string[];
}

export type RecommendedSpacesResponse = { threads: RecommendedThreadDTO[] };

export type RecommendedSpacesFetchParams = {
	cloudId: string;
	product: string;
	experienceId: string;
};

export const recommendedSpacesFetchAction = async ({
	cloudId,
	product,
	experienceId,
}: RecommendedSpacesFetchParams): Promise<RecommendedSpacesResponse> =>
	performHttpFetch({
		path: `${SPACES_API_PATH}/recommended`,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		},
	});
